import React from "react";
import { Link } from "react-router-dom";
import { resetPasswordUseCase, signInUseCase } from "../../usecases/user";
import { Button, dialog } from "../../nq-component";
import BasePage from "../../base/BasePage";
import withRouter from "../../withRouter";
import InputFactory from "../../components/InputFactory";
import ForgotPasswordPresenter from "./ForgotPasswordPresenter";
import { findObjectUseCase } from "../../usecases/object";
import { restUseCase } from "../../usecases/rest";
import { object } from "framer-motion/client";

class ForgotPasswordPage extends BasePage {
  constructor() {
    super();
    this.presenter = new ForgotPasswordPresenter(
      this,
      findObjectUseCase(),
      restUseCase(),
      resetPasswordUseCase(),
    );
    this.state = { progress: false, circular: false, object: {} };
  }

  formSubmit(e) {
    e.preventDefault();
    this.presenter.submit();
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }
async showSuccess(message, title) {
    const options = {
      title: title || "Success",
      message: message,
      icon: "bi bi-check-circle",
      type: "success",
      positiveButton: "OK",
      negativeButton: false,
    };

    try{
        await this.showDialog(options);

        this.navigateTo("/signin")
    }
    catch(error){
        
    }
  }

  render() {
    const { progress } = this.state;

    return (
      <div className="vh-100 d-flex align-items-center justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="bg-white rounded p-4">
            <div className="text-center mb-4">
              <img
                className="img-fluid login-img"
                alt="company logo"
                src="/lgs.jpeg"
                style={{ maxWidth: "150px", height: "auto" }}
              />
            </div>

            <div className="p-2 p-lg-4">
              <h2
                className="fw-bold text-center mb-2"
                style={{ color: "#d18237" }}
              >
                Reset Password
              </h2>
              <p className="text-black-50 text-center mb-4">
                Enter your email address and we'll send you instructions to
                reset your password
              </p>

              <form onSubmit={this.formSubmit.bind(this)}>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label fs-sm">Email Address</label>
                    <InputFactory
                      required
                      type="Email"
                      autoComplete="nope"
                      className="form-control bg-light-subtle p-2"
                      placeholder="Enter your email address"
                      field="email"
                      onChange={this.onChange.bind(this)}
                    />
                  </div>

                  <div className="col-12">
                    <Button
                      style={{ backgroundColor: "#d18237" }}
                      type="submit"
                      className="btn text-white w-100 fw-bold py-2 fs-6"
                      disabled={progress}
                    >
                      {progress ? "Please wait..." : "Send Reset Link"}
                    </Button>
                  </div>

                  <div className="col-12 text-center">
                    <Link
                      to={`/signin`}
                      className="text-decoration-none fw-medium"
                      style={{ color: "#d18237" }}
                    >
                      <i className="bi bi-arrow-left me-1"></i>Back to Login
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ForgotPasswordPage);
